/**
 * @generated SignedSource<<c74e64f9626b3d126179bcfb245fde5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SpeakerLabelUpdatePayload = {
  label: string;
  speaker: string;
  userId?: string | null;
};
export type TranscriptPanelRelabelMultipleSpeakersMutation$variables = {
  meetingRecordingId: string;
  updates: ReadonlyArray<SpeakerLabelUpdatePayload>;
};
export type TranscriptPanelRelabelMultipleSpeakersMutation$data = {
  readonly relabelMultipleRecordingSpeakers: {
    readonly meetingRecording: {
      readonly transcript: any | null;
    };
  } | null;
};
export type TranscriptPanelRelabelMultipleSpeakersMutation = {
  response: TranscriptPanelRelabelMultipleSpeakersMutation$data;
  variables: TranscriptPanelRelabelMultipleSpeakersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updates"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "meetingRecordingId",
    "variableName": "meetingRecordingId"
  },
  {
    "kind": "Variable",
    "name": "updates",
    "variableName": "updates"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transcript",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptPanelRelabelMultipleSpeakersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RelabelMultipleRecordingSpeakers",
        "kind": "LinkedField",
        "name": "relabelMultipleRecordingSpeakers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranscriptPanelRelabelMultipleSpeakersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RelabelMultipleRecordingSpeakers",
        "kind": "LinkedField",
        "name": "relabelMultipleRecordingSpeakers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "70072609361215eba867ff9a1e5fcaca",
    "id": null,
    "metadata": {},
    "name": "TranscriptPanelRelabelMultipleSpeakersMutation",
    "operationKind": "mutation",
    "text": "mutation TranscriptPanelRelabelMultipleSpeakersMutation(\n  $meetingRecordingId: ID!\n  $updates: [SpeakerLabelUpdatePayload!]!\n) {\n  relabelMultipleRecordingSpeakers(meetingRecordingId: $meetingRecordingId, updates: $updates) {\n    meetingRecording {\n      __typename\n      transcript\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2cea1fa2fb9d588f5917545e26a52b7";

export default node;
